import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-play-circle-fill text-lg"></i>
                </div>
                <span className="font-semibold text-lg text-foreground-950 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                  P站视频指南
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                最全面的P站视频使用指南平台，提供搜索技巧、分类导航、下载教程和热门推荐等实用内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                内容分类
              </h4>
              <ul className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                更多分类
              </h4>
              <ul className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                关于我们
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    网站首页
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} P站视频指南。本站为第三方独立内容指南网站，非P站视频官方网站。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}